import { DoctorListResponseDto } from "@/data/dto/admin/doctor-list-response-dto";
import { DoctorInfoEntity } from "@/domain/entity/admin/doctor-info-entity";
import { assertDoctorListResponseDto } from "@/utils/validation";

export class DoctorListMapper {
  /**
   * DTO를 Entity로 변환
   * @param dto - DoctorListResponseDto
   * @returns DoctorInfoEntity
   */
  static toEntity(dto: DoctorListResponseDto): DoctorInfoEntity {
    // AST 기반 타입 검증
    assertDoctorListResponseDto(dto);
    return {
      uuid: dto.uuid,
      name: dto.name,
      hospital: dto.hospital,
      treatmentCount: dto.treatmentCount,
      isDeactivated: dto.isDeactivated,
    };
  }

  /**
   * DTO 배열을 Entity 배열로 변환
   * @param dtos - DoctorListResponseDto[]
   * @returns DoctorInfoEntity[]
   */
  static toEntityList(dtos: DoctorListResponseDto[]): DoctorInfoEntity[] {
    return dtos.map((dto) => DoctorListMapper.toEntity(dto));
  }
}
